import { TableColumn } from '../interfaces';

export function constructStudentsReportTable(translationsList: object): TableColumn[] {
  return [
    { dataKey: 'userId', name: translationsList['STUDENTS_REPORT']['TABLE']['STUDENT_ID'] }, // Student ID
    { dataKey: 'student.user.fullName', name: translationsList['STUDENTS_REPORT']['TABLE']['NAME'] }, // Student Name
    { dataKey: 'student.user.email', name: translationsList['STUDENTS_REPORT']['TABLE']['EMAIL'] }, // Student Email
    {
      dataKey: 'student.user.gender',
      name: translationsList['STUDENTS_REPORT']['TABLE']['GENDER'], // Gender
    },
    {
      dataKey: 'student.phone',
      name: translationsList['STUDENTS_REPORT']['TABLE']['PHONE'], // Phone
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    {
      dataKey: 'student.age',
      name: translationsList['STUDENTS_REPORT']['TABLE']['AGE'], // Age
    },
    {
      dataKey: 'student.employmentStatus',
      name: translationsList['STUDENTS_REPORT']['TABLE']['EMPLOYMENT_STATUS'], // Employment Status
    },
    {
      dataKey: 'student.maritalStatus',
      name: translationsList['STUDENTS_REPORT']['TABLE']['MARITAL_STATUS'], // Marital Status
    },
    {
      dataKey: 'student.educationalLevel',
      name: translationsList['STUDENTS_REPORT']['TABLE']['EDUCATIONAL_LEVEL'], // Educational Level
    },
    // Commenting out the following columns as requested
    // { dataKey: 'student.type', name: translationsList['STUDENTS_REPORT']['TABLE']['STUDENT_TYPE'] }, // Student Type
    // { dataKey: 'student.user.city', name: translationsList['STUDENTS_REPORT']['TABLE']['CITY'] }, // City
    // { dataKey: 'student.isCallsBlocked', name: translationsList['STUDENTS_REPORT']['TABLE']['CALL_BLOCKING'] }, // Login Blocking
    // { dataKey: 'student.isLoginBlocked', name: translationsList['STUDENTS_REPORT']['TABLE']['LOGIN_BLOCKING'] }, // Payment Blocking
    // { dataKey: 'student.emailValid', name: translationsList['STUDENTS_REPORT']['TABLE']['EMAIL_VERIFICATION'], // Email Verification
    // },
    // { dataKey: 'rate', name: translationsList['STUDENTS_REPORT']['TABLE']['RATE'], // Rate
    // },
    // { dataKey: 'maqraatecSchool', name: translationsList['STUDENTS_REPORT']['TABLE']['MAQRATEC_SCHOOL'] }, // MAQRATEC School
    // { dataKey: 'studentPreference.agePreference', name: translationsList['STUDENTS_REPORT']['TABLE']['AGE_PREFERENCE'], // Age Preference
    // },
    // { dataKey: 'studentPreference.educationLevelPreference', name: translationsList['STUDENTS_REPORT']['TABLE']['EDUCATION_LEVEL_PREFERENCE'], // Education Level Preference
    //   hideDefaultCell: true,
    //   showCustomTemplateCell: true
    // },
    // { dataKey: 'studentPreference.pathPreference', name: translationsList['STUDENTS_REPORT']['TABLE']['EDUCATION_PATH_PREFERENCE'], // Education Path Preference
    //   hideDefaultCell: true,
    //   showCustomTemplateCell: true,
    //   showExpandableCell: true
    // },
    {
      dataKey: 'createdAt',
      name: translationsList['STUDENTS_REPORT']['TABLE']['REGISTER_DATE'], // Register Date
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    {
      dataKey: 'walletBalance',
      name: translationsList['STUDENTS_REPORT']['TABLE']['WALLET_BALANCE'], // Wallet Balance
    },
  ];
}

export function constructBalanceReportTable(translationsList: object): TableColumn[] {
  return [
    {
      dataKey: 'student.user.userId',
      name: translationsList['BALANCE_REPORT']['TABLE']['STUDENT_ID'],
    },

    {
      dataKey: 'student.user.fullName',
      name: translationsList['BALANCE_REPORT']['TABLE']['STUDENT_NAME'],
    },
    {
      dataKey: 'student.user.gender',
      name: translationsList['BALANCE_REPORT']['TABLE']['GENDER'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    {
      dataKey: 'student.user.phone',
      name: translationsList['BALANCE_REPORT']['TABLE']['PHONE'],
    },
    {
      dataKey: 'student.user.country',
      name: translationsList['BALANCE_REPORT']['TABLE']['COUNTRY'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    /**
     * @TODO Key of this package is not correct or need to be revised
     */
    {
      dataKey: 'consultantName',
      name: translationsList['BALANCE_REPORT']['TABLE']['CONSULTANT_NAME'],
    },
    /**
     * @TODO Key of this package is not correct or need to be revised
     */
    {
      dataKey: 'sessionType',
      name: translationsList['BALANCE_REPORT']['TABLE']['SESSION_TYPE'],
    },
    /**
     * @TODO Key of this package is not correct or need to be revised
     */
    // {
    //   dataKey: 'package.paidAmount',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['BALANCE_AMOUNT'],
    // },

    // {
    //   dataKey: 'package.packageName',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_NAME'],
    // },
    {
      dataKey: 'package.purchasedAt',
      name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_PURCHASED_DATE'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    // {
    //   dataKey: 'packageType',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_TYPE'],
    //   hideDefaultCell: true,
    //   showCustomTemplateCell: true,
    // },
    {
      dataKey: 'package.status',
      name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_STATUS'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    // {
    //   dataKey: 'date',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['PROMO_CODE'],
    // },
    {
      dataKey: 'package.discountPercent',
      name: translationsList['BALANCE_REPORT']['TABLE']['PROMO_CODE_PERCENTAGE'],
    },
    {
      dataKey: 'package.packageMinutes',
      name: translationsList['BALANCE_REPORT']['TABLE']['ORIGINAL_MINUTES'],
    },
    // {
    //   dataKey: 'package.balanceMinutes',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['BALANCE_MINUTES'],
    // },
    {
      dataKey: 'package.consumedMinutes',
      name: translationsList['BALANCE_REPORT']['TABLE']['CONSUMED_MINUTES'],
    },
    // {
    //   dataKey: 'remainedMinutes',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['REMAINED_MINUTES'],
    //   showCustomTemplateCell: true,
    //   hideDefaultCell: true,
    // },
    {
      dataKey: 'package.paidAmount',
      name: translationsList['BALANCE_REPORT']['TABLE']['PAID_AMOUNT'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    {
      dataKey: 'package.vatPercentage',
      name: translationsList['BALANCE_REPORT']['TABLE']['DISCOUNT_PERCENTAGE'],
    },
    // {
    //   dataKey: 'package.expiredAt',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_END_DATE'],
    //   showCustomTemplateCell: true,
    //   hideDefaultCell: true,
    // },
    // {
    //   dataKey: 'package.packageRemainingDays',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['REMAINING_DAYS']
    // },
    {
      dataKey: 'package.updatedAt',
      name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_CONSUMED_DATE'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    // {
    //   dataKey: 'package.extendAt',
    //   name: translationsList['BALANCE_REPORT']['TABLE']['PACKAGE_EXTEND_DATE'],
    //   showCustomTemplateCell: true,
    //   hideDefaultCell: true,
    // },
  ];
}

export function constructPayTabsReportTable(translationsList: object): TableColumn[] {
  return [
    { dataKey: 'transactionId', name: translationsList['PAY_TABS_REPORT']['TABLE']['TRANSACTION_ID'] },
    { dataKey: 'id', name: translationsList['PAY_TABS_REPORT']['TABLE']['ID'] },
    {
      dataKey: 'customerName',
      name: translationsList['PAY_TABS_REPORT']['TABLE']['CUSTOMER_NAME'],
    },
    {
      dataKey: 'customerPhone',
      name: translationsList['PAY_TABS_REPORT']['TABLE']['CUSTOMER_PHONE'],
    },
    {
      dataKey: 'customerIP',
      name: translationsList['PAY_TABS_REPORT']['TABLE']['CUSTOMER_IP'],
    },
    {
      dataKey: 'responseStatus',
      name: translationsList['PAY_TABS_REPORT']['TABLE']['TRANSACTION_STATUS'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    {
      dataKey: 'transactionResult',
      name: translationsList['PAY_TABS_REPORT']['TABLE']['REASON'],
      showExpandableCell: true,
    },
  ];
}

export function constructSessionsReportTable(translationsList: object): TableColumn[] {
  return [
    {
      dataKey: 'studentId',
      name: translationsList['CALLS_REPORT']['TABLE']['STUDENT_ID'],
    },
    {
      dataKey: 'studentName',
      name: translationsList['CALLS_REPORT']['TABLE']['STUDENT_NAME'],
    },
    {
      dataKey: 'teacherId',
      name: translationsList['CALLS_REPORT']['TABLE']['TEACHER_ID'],
    },
    {
      dataKey: 'teacherName',
      name: translationsList['CALLS_REPORT']['TABLE']['TEACHER_NAME'],
    },
    // { dataKey: 'studentLevel', name: translationsList['SESSIONS_REPORT']['TABLE']['STUDENT_LEVEL'] },
    {
      dataKey: 'createAt',
      name: translationsList['SESSIONS_REPORT']['TABLE']['SESSION_DATE'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    { dataKey: 'duration', name: translationsList['SESSIONS_REPORT']['TABLE']['TOTAL_SESSION_DURATION'] },
    /**
     * @TODO Key is not correct or need to be revised
     */
    { dataKey: 'type', name: translationsList['SESSIONS_REPORT']['TABLE']['SESSION_TYPE'] },
    // {
    //   dataKey: 'fromSurah',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['FROM_SURAH'],
    // },
    // { dataKey: 'toSurah', name: translationsList['SESSIONS_REPORT']['TABLE']['TO_SURAH'] },
    // {
    //   dataKey: 'fromVerse',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['FROM_VERSE'],
    // },
    // {
    //   dataKey: 'toVerse',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['TO_VERSE'],
    // },
    // {
    //   dataKey: 'assignmentValue',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['COMPLETED_PARTS_IN_SESSION'],
    // },
    // {
    //   dataKey: 'wordErrorCount',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['WORDS_MISTAKES'],
    // },
    // {
    //   dataKey: 'hesitationErrorCount',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['HESITATION'],
    // },
    // {
    //   dataKey: 'tajweedErrorCount',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['TAJWEED_MISTAKES'],
    // },
    // {
    //   dataKey: 'rate',
    //   name: translationsList['SESSIONS_REPORT']['TABLE']['RATE'],
    // },
    {
      dataKey: 'comment',
      name: translationsList['SESSIONS_REPORT']['TABLE']['COMMENT'],
    },
    {
      dataKey: 'studentCountry',
      name: translationsList['SESSIONS_REPORT']['TABLE']['COUNTRY'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    /**
     * @TODO Key is not correct or need to be revised
     */
    {
      dataKey: 'attachments',
      name: translationsList['SESSIONS_REPORT']['TABLE']['ATTACHMENTS'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
  ];
}

export function constructCallsReportTable(translationsList: object): TableColumn[] {
  return [
    { dataKey: 'studentId', name: translationsList['CALLS_REPORT']['TABLE']['STUDENT_ID'] },
    { dataKey: 'studentName', name: translationsList['CALLS_REPORT']['TABLE']['STUDENT_NAME'] },
    { dataKey: 'studentEmail', name: translationsList['CALLS_REPORT']['TABLE']['STUDENT_EMAIL'] },
    {
      dataKey: 'teacherId',
      name: translationsList['CALLS_REPORT']['TABLE']['TEACHER_ID'],
    },
    {
      dataKey: 'teacherName',
      name: translationsList['CALLS_REPORT']['TABLE']['TEACHER_NAME'],
    },
    { dataKey: 'teacherEmail', name: translationsList['CALLS_REPORT']['TABLE']['TEACHER_EMAIL'] },
    {
      dataKey: 'type',
      name: translationsList['CALLS_REPORT']['TABLE']['CALL_TYPE'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    { dataKey: 'status', name: translationsList['CALLS_REPORT']['TABLE']['CALL_STATUS'] },
    {
      dataKey: 'startDateTime',
      name: translationsList['CALLS_REPORT']['TABLE']['CALL_DATE'],
      showCustomTemplateCell: true,
      hideDefaultCell: true,
    },
    { dataKey: 'duration', name: translationsList['CALLS_REPORT']['TABLE']['CALL_DURATION'] },
    {
      dataKey: 'HangupBy',
      name: translationsList['CALLS_REPORT']['TABLE']['CALL_ENDED_BY'],
    },
  ];
}

export function constructDependentsReportTable(translationsList: object): TableColumn[] {
  return [
    { dataKey: 'parentId', name: translationsList['DEPENDENTS_REPORTS']['TABLE']['ACCOUNT_MANAGER_ID'] },
    { dataKey: 'parentName', name: translationsList['DEPENDENTS_REPORTS']['TABLE']['ACCOUNT_MANAGER_NAME'] },
    { dataKey: 'dependentId', name: translationsList['DEPENDENTS_REPORTS']['TABLE']['DEPENDENT_ID'] },
    {
      dataKey: 'dependentName',
      name: translationsList['DEPENDENTS_REPORTS']['TABLE']['DEPENDENT_NAME'],
    },
    {
      dataKey: 'totalDurationInMin',
      name: translationsList['DEPENDENTS_REPORTS']['TABLE']['TOTAL_MINUTES'],
    },
    { dataKey: 'totalConsumedInMin', name: translationsList['DEPENDENTS_REPORTS']['TABLE']['CONSUMED_MINUTES'] },
    {
      dataKey: 'totalDurationInMin',
      name: translationsList['DEPENDENTS_REPORTS']['TABLE']['REMAINING_MINUTES'],
    },
  ];
}

export function constructReservationsReportTable(translationsList: object): TableColumn[] {
  return [
    { dataKey: 'userId', name: translationsList['RESERVATIONS_REPORT']['TABLE']['STUDENT_ID'] },
    { dataKey: 'studentName', name: translationsList['RESERVATIONS_REPORT']['TABLE']['STUDENT_NAME'] },
    {
      dataKey: 'teacherId',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['TEACHER_ID'],
    },
    {
      dataKey: 'teacherName',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['TEACHER_NAME'],
    },
    {
      dataKey: 'schduleSlotFromDate',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['FROM'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },

    {
      dataKey: 'schduleSlotToDate',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['TO'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    {
      dataKey: 'createdAt',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['CREATED_AT'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
    {
      dataKey: 'canceled',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['RESERVATION_STATUS'],
    },
    {
      dataKey: 'callStatus',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['CALL_STATUS'],
    },
    {
      dataKey: 'reason',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['CANCELATION_REASON'],
    },
    {
      dataKey: 'callDurationSeconds',
      name: translationsList['RESERVATIONS_REPORT']['TABLE']['CALL_DURATION_IN_SECONDS'],
      hideDefaultCell: true,
      showCustomTemplateCell: true,
    },
  ];
}
